import { memo } from 'react';
import { Group, Stack, Text } from '@mantine/core';
import { Icon, IconName } from '@/ui/Icon/Icon';
import styles from './InputSection.module.css';

export const InputSection = memo(
  ({
    title,
    subtitle,
    iconName,
    rightSection,
    children,
    className,
  }: {
    title: string;
    subtitle?: string;
    iconName?: IconName;
    rightSection?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
  }) => {
    return (
      <Stack gap="md" p="md" w="100%" className={`${styles.inputSection} ${className}`}>
        <Group gap="md" justify="space-between">
          <Group align="center" gap="2xs">
            {iconName && <Icon name={iconName} />}
            <Stack gap={0}>
              <Text fw={500} size="md">
                {title}
              </Text>
              {subtitle && (
                <Text size="sm" c="dimmed">
                  {subtitle}
                </Text>
              )}
            </Stack>
          </Group>
          {rightSection}
        </Group>
        {children}
      </Stack>
    );
  }
);
